import script from "./ScanHistoryComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ScanHistoryComponent.vue?vue&type=script&setup=true&lang=js"

import "./ScanHistoryComponent.vue?vue&type=style&index=0&id=3fb12556&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fb12556"]])

export default __exports__